import { CarryOutFilled } from "@ant-design/icons";
import { Badge, Button } from "antd";
import React from "react";
import { pendingApprovalsStyles } from "./style/style";
import type { PendingApprovalProps } from "./types";

/**
 * PendingApproval Component
 * Renders a pill-style UI with icon, text, and badge count
 */
const PendingApprovals: React.FC<PendingApprovalProps> = ({ count, label = "Pending Approvals", onClick }) => {
  return (
    <Button type="default" onClick={onClick} style={pendingApprovalsStyles.button}>
      {/* Icon */}
      <CarryOutFilled height={28} width={28} style={pendingApprovalsStyles.icon} />

      {/* Label Text */}
      <span style={pendingApprovalsStyles.label}>{label}</span>

      {/* Badge Count */}
      <Badge count={count} style={pendingApprovalsStyles.badge} />
    </Button>
  );
};

export default PendingApprovals;
